// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
//   Button,
//   TextField,
//   InputAdornment,
//   Chip,
//   Grid,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Tooltip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Pagination,
//   Divider,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Tab,
//   Tabs
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import {
//   Visibility,
//   Edit,
//   Delete,
//   Search,
//   Refresh,
//   PictureAsPdf,
//   Download,
//   CalendarToday,
//   Person,
//   Business,
//   Close,
//   Print,
//   Save,
//   Assignment,
//   VerifiedUser,
//   Group
// } from '@mui/icons-material';
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { 
//   GetDataFromApiWithParams, 
//   DeleteAndGetResponse,
//   ExecutePostWithParams, 
//   UpdateAndGetResponse
// } from "../../../../services/api/ExecuteApiRequests";

// // Styled components
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 'bold',
//   backgroundColor: '#f5f5f5',
//   fontFamily: '"Times New Roman", Times, serif',
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: '#fafafa',
//   },
//   '&:hover': {
//     backgroundColor: '#f0f0f0',
//   },
// }));

// const TimesTypography = styled(Typography)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif !important',
//   color: '#000000',
// }));

// const ConsistentTableCell = styled(TableCell)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   fontSize: '0.875rem',
//   color: '#000000',
// }));

// const IconText = styled('span')(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   fontSize: '0.875rem',
//   color: '#000000',
// }));

// // Light Gray Button Styles
// const LightGrayOutlinedButton = styled(Button)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   backgroundColor: '#f0f0f0',
//   color: '#000000',
//   borderColor: '#cccccc',
//   '&:hover': {
//     backgroundColor: '#e0e0e0',
//     borderColor: '#999999',
//   },
//   '&:disabled': {
//     backgroundColor: '#e0e0e0',
//     color: '#999999',
//   }
// }));

// const LightGrayContainedButton = styled(Button)(({ theme }) => ({
//   fontFamily: '"Times New Roman", Times, serif',
//   backgroundColor: '#f0f0f0',
//   color: '#000000',
//   '&:hover': {
//     backgroundColor: '#e0e0e0',
//   },
//   '&:disabled': {
//     backgroundColor: '#e0e0e0',
//     color: '#999999',
//   }
// }));

// // Tab Panel Component
// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 2 }}>
//           {children}
//         </Box>
//       )}
//     </div>
//   );
// }

// export default function HandoverListView() {
//   const [handovers, setHandovers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedHandover, setSelectedHandover] = useState(null);
//   const [viewDialogOpen, setViewDialogOpen] = useState(false);
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [refreshing, setRefreshing] = useState(false);
//   const [editTabValue, setEditTabValue] = useState(0);
//   const [editFormData, setEditFormData] = useState({
//     id: '',
//     agreement_id: '',
//     date_of_handover: '',
//     handed_over_by: '',
//     handed_over_to: '',
//     notes: '',
//     description: '',
//     park_id: '',
//     signatures: [],
//     checklist_items: []
//   });
//   const [saving, setSaving] = useState(false);
  
//   // Ref for print content
//   const printContentRef = useRef();

//   // Fetch handovers on component mount and when page/filter changes
//   useEffect(() => {
//     fetchHandovers();
//   }, [page, filterStatus]);

//   const fetchHandovers = async () => {
//     setLoading(true);
//     try {
//       const params = {
//         page: page,
//         status: filterStatus,
//         search: searchTerm
//       };
      
//       const response = await GetDataFromApiWithParams(`parks/handover`, params);
      
//       console.log("API Response:", response);
      
//       if (Array.isArray(response)) {
//         setHandovers(response);
//         setTotalPages(Math.ceil(response.length / 10) || 1);
//       } 
//       else if (response && response.data && Array.isArray(response.data)) {
//         setHandovers(response.data);
//         setTotalPages(response.totalPages || 1);
//       }
//       else {
//         console.warn("Unexpected response format:", response);
//         setHandovers([]);
//         setTotalPages(1);
//       }
//     } catch (error) {
//       console.error("Error fetching handovers:", error);
//       toast.error("Failed to load handover records", { position: "top-right" });
//       setHandovers(generateMockHandovers());
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Generate mock data for demonstration
//   const generateMockHandovers = () => {
//     const statuses = ['Completed', 'Pending', 'In Progress'];
//     const investors = ['ABC Construction', 'XYZ Industries', 'Global Trading', 'Tech Solutions', 'Green Energy'];
    
//     return Array.from({ length: 10 }, (_, i) => ({
//       id: `HDO-${1000 + i}`,
//       date_of_handover: new Date(2024, 0, 15 + i).toISOString().split('T')[0],
//       handed_over_by: `John Doe ${i + 1}`,
//       handed_over_to: investors[i % investors.length],
//       agreement_id: `AGR-${2000 + i}`,
//       park_id: `PARK-${Math.floor(i/2) + 1}`,
//       status: statuses[i % statuses.length],
//       description: `Handover description for record ${i + 1}`,
//       notes: `Additional notes for handover ${i + 1}`,
//       created_at: new Date(2024, 0, 10 + i).toISOString(),
//       signed_document_url: i % 3 === 0 ? '/documents/sample.pdf' : null,
//       signatures: [
//         {
//           ipdc_vice_name: 'John Vice',
//           ipdc_vice_position: 'Manager',
//           ipdc_vice_signature: 'encrypted_signature_1',
//           ipdc_vice_date: new Date(2024, 0, 15 + i).toISOString().split('T')[0],
//           investor_name: 'Jane Investor',
//           investor_position: 'Director',
//           investor_signature: 'encrypted_signature_2',
//           investor_date: new Date(2024, 0, 15 + i).toISOString().split('T')[0],
//           ipdc_kisez_name: 'Bob Kisez',
//           ipdc_kisez_position: 'KISEZ Manager',
//           ipdc_kisez_signature: 'encrypted_signature_3',
//           ipdc_kisez_date: new Date(2024, 0, 15 + i).toISOString().split('T')[0],
//           witness1_name: 'Witness One',
//           witness2_name: 'Witness Two',
//           witness3_name: 'Witness Three'
//         }
//       ],
//       checklist_items: [
//         {
//           id: 1,
//           inspection_no: 1,
//           item_name: 'Fire Extinguisher',
//           status: 'Good',
//           accept_reject: 'Accept',
//           remarks: 'All working'
//         },
//         {
//           id: 2,
//           inspection_no: 2,
//           item_name: 'Emergency Lights',
//           status: 'Needs repair',
//           accept_reject: 'Pending',
//           remarks: 'One light not working'
//         },
//         {
//           id: 3,
//           inspection_no: 3,
//           item_name: 'Fire Alarm System',
//           status: 'Operational',
//           accept_reject: 'Accept',
//           remarks: 'Tested and working'
//         },
//         {
//           id: 4,
//           inspection_no: 4,
//           item_name: 'Exit Signs',
//           status: 'Good',
//           accept_reject: 'Accept',
//           remarks: 'All illuminated'
//         }
//       ]
//     }));
//   };

//   const handleSearch = () => {
//     setPage(1);
//     fetchHandovers();
//   };

//   const handleRefresh = async () => {
//     setRefreshing(true);
//     await fetchHandovers();
//     setRefreshing(false);
//     toast.success("Data refreshed successfully", { position: "top-right" });
//   };

//   const handleView = (handover) => {
//     setSelectedHandover(handover);
//     setViewDialogOpen(true);
//   };

//   const handleEdit = (handover) => {
//     console.log("Opening edit dialog for:", handover);
//     setSelectedHandover(handover);
//     setEditFormData({
//       id: handover.id || '',
//       agreement_id: handover.agreement_id || '',
//       date_of_handover: handover.date_of_handover || '',
//       handed_over_by: handover.handed_over_by || '',
//       handed_over_to: handover.handed_over_to || '',
//       notes: handover.notes || '',
//       description: handover.description || '',
//       park_id: handover.park_id || '',
//       signatures: handover.signatures || [],
//       checklist_items: handover.checklist_items || []
//     });
//     setEditTabValue(0);
//     setEditDialogOpen(true);
//   };

//   const handleEditFormChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSignatureChange = (index, field, value) => {
//     setEditFormData(prev => {
//       const updatedSignatures = [...prev.signatures];
//       updatedSignatures[index] = {
//         ...updatedSignatures[index],
//         [field]: value
//       };
//       return {
//         ...prev,
//         signatures: updatedSignatures
//       };
//     });
//   };

//   const handleChecklistItemChange = (index, field, value) => {
//     setEditFormData(prev => {
//       const updatedItems = [...prev.checklist_items];
//       updatedItems[index] = {
//         ...updatedItems[index],
//         [field]: value
//       };
//       return {
//         ...prev,
//         checklist_items: updatedItems
//       };
//     });
//   };

//   const handleSaveEdit = async () => {
//     setSaving(true);
//     try {
//       // Call API to update handover with all data
//       console.log("Saving edited data:", editFormData);
//       await UpdateAndGetResponse(`parks/handover/${editFormData.id}`, editFormData);
      
//       toast.success("Handover updated successfully", { position: "top-right" });
//       setEditDialogOpen(false);
//       fetchHandovers(); // Refresh the list
//     } catch (error) {
//       console.error("Error updating handover:", error);
//       toast.error("Failed to update handover", { position: "top-right" });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDeleteClick = (handover) => {
//     setSelectedHandover(handover);
//     setDeleteDialogOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!selectedHandover) return;
    
//     try {
//       await DeleteAndGetResponse(`parks/handover/${selectedHandover.id}`);
//       toast.success("Handover deleted successfully", { position: "top-right" });
//       fetchHandovers();
//     } catch (error) {
//       console.error("Error deleting handover:", error);
//       toast.error("Failed to delete handover", { position: "top-right" });
//     } finally {
//       setDeleteDialogOpen(false);
//       setSelectedHandover(null);
//     }
//   };

//   // Print function
//   const handlePrint = () => {
//     const printWindow = window.open('', '_blank');
//     if (printWindow && selectedHandover) {
//       const content = generatePrintContent(selectedHandover);
//       printWindow.document.write(content);
//       printWindow.document.close();
//       printWindow.focus();
//       printWindow.print();
//     }
//   };

//   // Generate print content
//   const generatePrintContent = (handover) => {
//     return `
//       <!DOCTYPE html>
//       <html>
//         <head>
//           <title>Handover Details - ${handover.id}</title>
//           <style>
//             body { 
//               font-family: 'Times New Roman', Times, serif; 
//               margin: 40px;
//               color: #000000;
//             }
//             h1 { font-size: 24px; margin-bottom: 20px; }
//             h2 { font-size: 18px; margin: 20px 0 10px; border-bottom: 1px solid #ccc; }
//             .section { margin-bottom: 30px; }
//             .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; }
//             .field { margin-bottom: 10px; }
//             .label { font-weight: normal; }
//             table { width: 100%; border-collapse: collapse; margin-top: 15px; }
//             th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//             th { background-color: #f5f5f5; }
//             .signature-box { 
//               border: 1px solid #ddd; 
//               padding: 15px; 
//               margin-bottom: 15px;
//               background-color: #f9f9f9;
//             }
//           </style>
//         </head>
//         <body>
//           <h1>Handover Details - ${handover.id}</h1>
          
//           <div class="section">
//             <h2>Basic Information</h2>
//             <div class="grid">
//               <div class="field"><span class="label">Handover ID:</span> ${handover.id}</div>
//               <div class="field"><span class="label">Handover Date:</span> ${formatDate(handover.date_of_handover)}</div>
//               <div class="field"><span class="label">Park ID:</span> ${handover.park_id || 'N/A'}</div>
//               <div class="field"><span class="label">Agreement ID:</span> ${handover.agreement_id || 'N/A'}</div>
//               <div class="field"><span class="label">Handed Over By:</span> ${handover.handed_over_by || 'N/A'}</div>
//               <div class="field"><span class="label">Handed Over To:</span> ${handover.handed_over_to || 'N/A'}</div>
//             </div>
//           </div>

//           <div class="section">
//             <h2>Description & Notes</h2>
//             <div class="field"><span class="label">Description:</span> ${handover.description || 'No description provided'}</div>
//             <div class="field"><span class="label">Notes:</span> ${handover.notes || 'No notes provided'}</div>
//             ${handover.attachment_paths ? `<div class="field"><span class="label">Attachment:</span> ${handover.attachment_paths}</div>` : ''}
//           </div>

//           ${handover.signatures && handover.signatures.length > 0 ? `
//             <div class="section">
//               <h2>Signatures & Witnesses</h2>
//               ${handover.signatures.map(sig => `
//                 <div style="margin-bottom: 30px;">
//                   <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; margin-bottom: 15px;">
//                     <div class="signature-box">
//                       <h3>IPDC Vice E & Technic Manager</h3>
//                       <div><span class="label">Name:</span> ${sig.ipdc_vice_name || 'N/A'}</div>
//                       <div><span class="label">Position:</span> ${sig.ipdc_vice_position || 'N/A'}</div>
//                       <div><span class="label">Date:</span> ${formatDate(sig.ipdc_vice_date)}</div>
//                     </div>
//                     <div class="signature-box">
//                       <h3>Investor Company</h3>
//                       <div><span class="label">Name:</span> ${sig.investor_name || 'N/A'}</div>
//                       <div><span class="label">Position:</span> ${sig.investor_position || 'N/A'}</div>
//                       <div><span class="label">Date:</span> ${formatDate(sig.investor_date)}</div>
//                     </div>
//                     <div class="signature-box">
//                       <h3>IPDC KISEZ Manager</h3>
//                       <div><span class="label">Name:</span> ${sig.ipdc_kisez_name || 'N/A'}</div>
//                       <div><span class="label">Position:</span> ${sig.ipdc_kisez_position || 'N/A'}</div>
//                       <div><span class="label">Date:</span> ${formatDate(sig.ipdc_kisez_date)}</div>
//                     </div>
//                   </div>
//                   <div class="signature-box">
//                     <h3>Witnesses</h3>
//                     <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px;">
//                       <div><span class="label">Witness 1:</span> ${sig.witness1_name || 'N/A'}</div>
//                       <div><span class="label">Witness 2:</span> ${sig.witness2_name || 'N/A'}</div>
//                       <div><span class="label">Witness 3:</span> ${sig.witness3_name || 'N/A'}</div>
//                     </div>
//                   </div>
//                 </div>
//               `).join('')}
//             </div>
//           ` : ''}

//           ${handover.checklist_items && handover.checklist_items.length > 0 ? `
//             <div class="section">
//               <h2>Checklist Items (${handover.checklist_items.length})</h2>
//               <table>
//                 <thead>
//                   <tr>
//                     <th>No.</th>
//                     <th>Item Name</th>
//                     <th>Status</th>
//                     <th>Accept/Reject</th>
//                     <th>Remarks</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${handover.checklist_items.map(item => `
//                     <tr>
//                       <td>${item.inspection_no}</td>
//                       <td>${item.item_name}</td>
//                       <td>${item.status || 'N/A'}</td>
//                       <td>${item.accept_reject || 'Pending'}</td>
//                       <td>${item.remarks || 'N/A'}</td>
//                     </tr>
//                   `).join('')}
//                 </tbody>
//               </table>
//             </div>
//           ` : ''}
//         </body>
//       </html>
//     `;
//   };

//   // Updated getStatusChip with light gray colors
//   const getStatusChip = (status) => {
//     // Light gray color map for different statuses
//     const bgColorMap = {
//       'Completed': '#e0e0e0',    // Light gray
//       'Pending': '#f5f5f5',       // Very light gray
//       'In Progress': '#d3d3d3',   // Medium light gray
//       'default': '#f0f0f0'        // Default light gray
//     };
    
//     return (
//       <Chip 
//         label={status || 'Unknown'} 
//         size="small"
//         sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           backgroundColor: bgColorMap[status] || bgColorMap.default,
//           color: '#000000',
//           fontWeight: 400,
//           fontSize: '0.75rem',
//           '&:hover': {
//             backgroundColor: '#c0c0c0',
//           }
//         }}
//       />
//     );
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   return (
//     <Box sx={{ p: 3, fontFamily: '"Times New Roman", Times, serif' }}>
//       <ToastContainer 
//         toastStyle={{ fontFamily: '"Times New Roman", Times, serif' }}
//       />
      
//       {/* Header */}
//       <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//           <TimesTypography variant="h5" sx={{ fontWeight: 'bold' }}>
//             Handover Records
//           </TimesTypography>
//           <Box sx={{ display: 'flex', gap: 2 }}>
//             <LightGrayOutlinedButton
//               variant="outlined"
//               startIcon={<Refresh />}
//               onClick={handleRefresh}
//               disabled={refreshing}
//             >
//               {refreshing ? 'Refreshing...' : 'Refresh'}
//             </LightGrayOutlinedButton>
            
//             <LightGrayContainedButton
//               variant="contained"
//               startIcon={<PictureAsPdf />}
//             >
//               Export Report
//             </LightGrayContainedButton>
//           </Box>
//         </Box>
//       </Paper>

//       {/* Filters and Search */}
//       <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={4}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search by ID, Investor, or Description..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchTerm && (
//                   <InputAdornment position="end">
//                     <IconButton size="small" onClick={() => setSearchTerm('')}>
//                       <Close fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 style: { fontFamily: '"Times New Roman", Times, serif' }
//               }}
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <FormControl fullWidth size="small">
//               <InputLabel sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Status Filter</InputLabel>
//               <Select
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//                 label="Status Filter"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               >
//                 <MenuItem value="all" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>All Status</MenuItem>
//                 <MenuItem value="Completed" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Completed</MenuItem>
//                 <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
//                 <MenuItem value="In Progress" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>In Progress</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} md={2}>
//             <LightGrayContainedButton
//               variant="contained"
//               onClick={handleSearch}
//               fullWidth
//             >
//               Search
//             </LightGrayContainedButton>
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <TimesTypography variant="body2" color="textSecondary">
//               Total Records: {handovers.length}
//             </TimesTypography>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Table */}
//       <Paper elevation={2} sx={{ width: '100%', overflow: 'hidden' }}>
//         <TableContainer sx={{ maxHeight: 500 }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <StyledTableCell>ID</StyledTableCell>
//                 <StyledTableCell>Handover Date</StyledTableCell>
//                 <StyledTableCell>Handed Over By</StyledTableCell>
//                 <StyledTableCell>Handed Over To</StyledTableCell>
//                 <StyledTableCell>Agreement ID</StyledTableCell>
//                 <StyledTableCell>Description</StyledTableCell>
//                 <StyledTableCell align="center">Actions</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {loading ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
//                     <CircularProgress />
//                     <TimesTypography sx={{ mt: 2 }}>Loading handover records...</TimesTypography>
//                   </TableCell>
//                 </TableRow>
//               ) : handovers.length === 0 ? (
//                 <TableRow>
//                   <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
//                     <TimesTypography variant="h6" color="textSecondary">
//                       No handover records found
//                     </TimesTypography>
//                   </TableCell>
//                 </TableRow>
//               ) : (
//                 handovers.map((handover) => (
//                   <StyledTableRow key={handover.id}>
//                     <ConsistentTableCell>
//                       {handover.id}
//                     </ConsistentTableCell>
                    
//                     <ConsistentTableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                         <CalendarToday fontSize="small" sx={{ color: '#000000' }} />
//                         <IconText>{formatDate(handover.date_of_handover)}</IconText>
//                       </Box>
//                     </ConsistentTableCell>

//                     <ConsistentTableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                         <Person fontSize="small" sx={{ color: '#000000' }} />
//                         <IconText>{handover.handed_over_by}</IconText>
//                       </Box>
//                     </ConsistentTableCell>

//                     <ConsistentTableCell>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                       <Person fontSize="small" sx={{ color: '#000000' }} /> 
//                         <IconText>{handover.handed_over_to}</IconText>
//                       </Box>
//                     </ConsistentTableCell>

//                     <ConsistentTableCell>
//                       {handover.agreement_id}
//                     </ConsistentTableCell>

//                     <ConsistentTableCell>
//                       {handover.description || "No"}
//                     </ConsistentTableCell>
                   
//                     <ConsistentTableCell align="center">
//                       <Tooltip title="View Details">
//                         <IconButton 
//                           size="small" 
//                           sx={{ color: '#000000' }}
//                           onClick={() => handleView(handover)}
//                         >
//                           <Visibility fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Edit">
//                         <IconButton 
//                           size="small" 
//                           sx={{ color: '#000000' }}
//                           onClick={() => handleEdit(handover)}
//                         >
//                           <Edit fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       {handover.signed_document_url && (
//                         <Tooltip title="Download Document">
//                           <IconButton 
//                             size="small" 
//                             sx={{ color: '#000000' }}
//                             href={handover.signed_document_url}
//                             download
//                           >
//                             <Download fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       )}
//                       <Tooltip title="Delete">
//                         <IconButton 
//                           size="small" 
//                           color="error"
//                           onClick={() => handleDeleteClick(handover)}
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </ConsistentTableCell>
//                   </StyledTableRow>
//                 ))
//               )}
//             </TableBody>
//           </Table>
//         </TableContainer>
        
//         {/* Pagination */}
//         <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//           <Pagination 
//             count={totalPages} 
//             page={page} 
//             onChange={(e, value) => setPage(value)}
//             color="primary"
//             sx={{
//               '& .MuiPaginationItem-root': {
//                 fontFamily: '"Times New Roman", Times, serif'
//               }
//             }}
//           />
//         </Box>
//       </Paper>

//       {/* View Details Dialog */}
//       <Dialog 
//         open={viewDialogOpen} 
//         onClose={() => setViewDialogOpen(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           Handover Details - {selectedHandover?.id}
//           <Box>
//             <Tooltip title="Print">
//               <IconButton onClick={handlePrint} sx={{ mr: 1 }}>
//                 <Print />
//               </IconButton>
//             </Tooltip>
//             <IconButton onClick={() => setViewDialogOpen(false)}>
//               <Close />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent dividers ref={printContentRef}>
//           {selectedHandover && (
//             <Grid container spacing={3}>
//               {/* Basic Information */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ mb: 2 }}>
//                   <CardContent>
//                     <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                       Basic Information
//                     </TimesTypography>
//                     <Divider sx={{ mb: 2 }} />
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handover ID: {selectedHandover.id}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handover Date: {formatDate(selectedHandover.date_of_handover)}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Park ID: {selectedHandover.park_id || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Agreement ID: {selectedHandover.agreement_id || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handed Over By: {selectedHandover.handed_over_by || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={4}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Handed Over To: {selectedHandover.handed_over_to || 'N/A'}
//                         </TimesTypography>
//                       </Grid>
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Description and Notes */}
//               <Grid item xs={12}>
//                 <Card variant="outlined" sx={{ mb: 2 }}>
//                   <CardContent>
//                     <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                       Description & Notes
//                     </TimesTypography>
//                     <Divider sx={{ mb: 2 }} />
//                     <Grid container spacing={2}>
//                       <Grid item xs={12}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Description: {selectedHandover.description || 'No description provided'}
//                         </TimesTypography>
//                       </Grid>
//                       <Grid item xs={12}>
//                         <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                           Notes: {selectedHandover.notes || 'No notes provided'}
//                         </TimesTypography>
//                       </Grid>
//                       {selectedHandover.attachment_paths && (
//                         <Grid item xs={12}>
//                           <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                             Attachment: {selectedHandover.attachment_paths}
//                           </TimesTypography>
//                           <Button
//                             variant="outlined"
//                             startIcon={<Download />}
//                             href={selectedHandover.attachment_paths}
//                             target="_blank"
//                             size="small"
//                             sx={{ 
//                               mt: 1, 
//                               fontFamily: '"Times New Roman", Times, serif',
//                               color: '#000000',
//                               borderColor: '#cccccc'
//                             }}
//                           >
//                             Download Attachment
//                           </Button>
//                         </Grid>
//                       )}
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Signatures Section */}
//               {selectedHandover.signatures && selectedHandover.signatures.length > 0 && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined" sx={{ mb: 2 }}>
//                     <CardContent>
//                       <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                         Signatures & Witnesses
//                       </TimesTypography>
//                       <Divider sx={{ mb: 2 }} />
//                       {selectedHandover.signatures.map((sig, index) => (
//                         <Box key={index} sx={{ mt: 2 }}>
//                           <Grid container spacing={2}>
//                             {/* IPDC Vice Section */}
//                             <Grid item xs={12} md={4}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   IPDC Vice E & Technic Manager
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Name: {sig.ipdc_vice_name || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Position: {sig.ipdc_vice_position || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Date: {formatDate(sig.ipdc_vice_date)}
//                                 </TimesTypography>
//                               </Paper>
//                             </Grid>

//                             {/* Investor Section */}
//                             <Grid item xs={12} md={4}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   Investor Company
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Name: {sig.investor_name || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Position: {sig.investor_position || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Date: {formatDate(sig.investor_date)}
//                                 </TimesTypography>
//                               </Paper>
//                             </Grid>

//                             {/* IPDC KISEZ Section */}
//                             <Grid item xs={12} md={4}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   IPDC KISEZ Manager
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Name: {sig.ipdc_kisez_name || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Position: {sig.ipdc_kisez_position || 'N/A'}
//                                 </TimesTypography>
//                                 <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                   Date: {formatDate(sig.ipdc_kisez_date)}
//                                 </TimesTypography>
//                               </Paper>
//                             </Grid>

//                             {/* Witnesses Section */}
//                             <Grid item xs={12}>
//                               <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9', mt: 1 }}>
//                                 <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
//                                   Witnesses
//                                 </TimesTypography>
//                                 <Grid container spacing={2}>
//                                   <Grid item xs={12} sm={4}>
//                                     <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                       Witness 1: {sig.witness1_name || 'N/A'}
//                                     </TimesTypography>
//                                   </Grid>
//                                   <Grid item xs={12} sm={4}>
//                                     <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                       Witness 2: {sig.witness2_name || 'N/A'}
//                                     </TimesTypography>
//                                   </Grid>
//                                   <Grid item xs={12} sm={4}>
//                                     <TimesTypography variant="body2" sx={{ color: '#000000' }}>
//                                       Witness 3: {sig.witness3_name || 'N/A'}
//                                     </TimesTypography>
//                                   </Grid>
//                                 </Grid>
//                               </Paper>
//                             </Grid>
//                           </Grid>
//                         </Box>
//                       ))}
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}

//               {/* Checklist Items Section */}
//               {selectedHandover.checklist_items && selectedHandover.checklist_items.length > 0 && (
//                 <Grid item xs={12}>
//                   <Card variant="outlined">
//                     <CardContent>
//                       <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
//                         Checklist Items ({selectedHandover.checklist_items.length})
//                       </TimesTypography>
//                       <Divider sx={{ mb: 2 }} />
//                       <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, maxHeight: 300 }}>
//                         <Table size="small" stickyHeader>
//                           <TableHead>
//                             <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>No.</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Item Name</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Status</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Accept/Reject</TableCell>
//                               <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Remarks</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {selectedHandover.checklist_items.map((item) => (
//                               <TableRow key={item.id}>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.inspection_no}</TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.item_name}</TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.status || 'N/A'}</TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>
//                                   <Chip 
//                                     label={item.accept_reject || 'Pending'} 
//                                     size="small"
//                                     sx={{
//                                       fontFamily: '"Times New Roman", Times, serif',
//                                       backgroundColor: 
//                                         item.accept_reject === 'Accept' ? '#e0e0e0' : 
//                                         item.accept_reject === 'Reject' ? '#e0e0e0' : 
//                                         '#f5f5f5',
//                                       color: '#000000'
//                                     }}
//                                   />
//                                 </TableCell>
//                                 <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.remarks || 'N/A'}</TableCell>
//                               </TableRow>
//                             ))}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               )}
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <LightGrayOutlinedButton onClick={() => setViewDialogOpen(false)}>
//             Close
//           </LightGrayOutlinedButton>
//         </DialogActions>
//       </Dialog>

//       {/* Edit Handover Dialog - Comprehensive with all data */}
//       <Dialog 
//         open={editDialogOpen} 
//         onClose={() => setEditDialogOpen(false)}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ 
//           fontFamily: '"Times New Roman", Times, serif',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center'
//         }}>
//           Edit Handover - {editFormData.id}
//           <IconButton onClick={() => setEditDialogOpen(false)}>
//             <Close />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent dividers>
//           <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
//             <Tabs 
//               value={editTabValue} 
//               onChange={(e, newValue) => setEditTabValue(newValue)}
//               aria-label="edit handover tabs"
//             >
//               <Tab 
//                 icon={<Business />} 
//                 label="Basic Info" 
//                 iconPosition="start"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               />
//               <Tab 
//                 icon={<VerifiedUser />} 
//                 label="Signatures" 
//                 iconPosition="start"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               />
//               <Tab 
//                 icon={<Assignment />} 
//                 label="Checklist Items" 
//                 iconPosition="start"
//                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//               />
//             </Tabs>
//           </Box>

//           {/* Basic Information Tab */}
//           <TabPanel value={editTabValue} index={0}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Agreement ID"
//                   name="agreement_id"
//                   value={editFormData.agreement_id}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Handover Date"
//                   name="date_of_handover"
//                   type="date"
//                   value={editFormData.date_of_handover}
//                   onChange={handleEditFormChange}
//                   InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Handed Over By"
//                   name="handed_over_by"
//                   value={editFormData.handed_over_by}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Handed Over To"
//                   name="handed_over_to"
//                   value={editFormData.handed_over_to}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Park ID"
//                   name="park_id"
//                   value={editFormData.park_id}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Description"
//                   name="description"
//                   multiline
//                   rows={2}
//                   value={editFormData.description}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   size="small"
//                   label="Notes"
//                   name="notes"
//                   multiline
//                   rows={2}
//                   value={editFormData.notes}
//                   onChange={handleEditFormChange}
//                   sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                   InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                   inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                 />
//               </Grid>
//             </Grid>
//           </TabPanel>

//           {/* Signatures Tab */}
//           <TabPanel value={editTabValue} index={1}>
//             {editFormData.signatures && editFormData.signatures.length > 0 ? (
//               editFormData.signatures.map((sig, index) => (
//                 <Accordion key={index} defaultExpanded={index === 0}>
//                   <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                     <Typography sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
//                       Signature Set {index + 1}
//                     </Typography>
//                   </AccordionSummary>
//                   <AccordionDetails>
//                     <Grid container spacing={2}>
//                       {/* IPDC Vice Section */}
//                       <Grid item xs={12} md={4}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             IPDC Vice E & Technic Manager
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Name"
//                             value={sig.ipdc_vice_name || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_name', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Position"
//                             value={sig.ipdc_vice_position || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_position', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Signature"
//                             value={sig.ipdc_vice_signature || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_signature', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Date"
//                             type="date"
//                             value={sig.ipdc_vice_date || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_vice_date', e.target.value)}
//                             InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </Card>
//                       </Grid>

//                       {/* Investor Section */}
//                       <Grid item xs={12} md={4}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             Investor Company
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Name"
//                             value={sig.investor_name || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_name', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Position"
//                             value={sig.investor_position || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_position', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Signature"
//                             value={sig.investor_signature || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_signature', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Date"
//                             type="date"
//                             value={sig.investor_date || ''}
//                             onChange={(e) => handleSignatureChange(index, 'investor_date', e.target.value)}
//                             InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </Card>
//                       </Grid>

//                       {/* IPDC KISEZ Section */}
//                       <Grid item xs={12} md={4}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             IPDC KISEZ Manager
//                           </Typography>
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Name"
//                             value={sig.ipdc_kisez_name || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_name', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Position"
//                             value={sig.ipdc_kisez_position || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_position', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Signature"
//                             value={sig.ipdc_kisez_signature || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_signature', e.target.value)}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                           <TextField
//                             fullWidth
//                             size="small"
//                             label="Date"
//                             type="date"
//                             value={sig.ipdc_kisez_date || ''}
//                             onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_date', e.target.value)}
//                             InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                             sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </Card>
//                       </Grid>

//                       {/* Witnesses */}
//                       <Grid item xs={12}>
//                         <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
//                           <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
//                             Witnesses
//                           </Typography>
//                           <Grid container spacing={2}>
//                             <Grid item xs={12} sm={4}>
//                               <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Witness 1"
//                                 value={sig.witness1_name || ''}
//                                 onChange={(e) => handleSignatureChange(index, 'witness1_name', e.target.value)}
//                                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                                 InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                                 inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                               />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                               <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Witness 2"
//                                 value={sig.witness2_name || ''}
//                                 onChange={(e) => handleSignatureChange(index, 'witness2_name', e.target.value)}
//                                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                                 InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                                 inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                               />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                               <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Witness 3"
//                                 value={sig.witness3_name || ''}
//                                 onChange={(e) => handleSignatureChange(index, 'witness3_name', e.target.value)}
//                                 sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                                 InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                                 inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                               />
//                             </Grid>
//                           </Grid>
//                         </Card>
//                       </Grid>
//                     </Grid>
//                   </AccordionDetails>
//                 </Accordion>
//               ))
//             ) : (
//               <Typography sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#999' }}>
//                 No signature data available
//               </Typography>
//             )}
//           </TabPanel>

//           {/* Checklist Items Tab */}
//           <TabPanel value={editTabValue} index={2}>
//             {editFormData.checklist_items && editFormData.checklist_items.length > 0 ? (
//               <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>No.</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Item Name</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Status</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Accept/Reject</TableCell>
//                       <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Remarks</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {editFormData.checklist_items.map((item, index) => (
//                       <TableRow key={item.id || index}>
//                         <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{item.inspection_no}</TableCell>
//                         <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{item.item_name}</TableCell>
//                         <TableCell>
//                           <TextField
//                             size="small"
//                             value={item.status || ''}
//                             onChange={(e) => handleChecklistItemChange(index, 'status', e.target.value)}
//                             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </TableCell>
//                         <TableCell>
//                           <Select
//                             size="small"
//                             value={item.accept_reject || 'Pending'}
//                             onChange={(e) => handleChecklistItemChange(index, 'accept_reject', e.target.value)}
//                             sx={{ fontFamily: '"Times New Roman", Times, serif', minWidth: 100 }}
//                           >
//                             <MenuItem value="Accept" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Accept</MenuItem>
//                             <MenuItem value="Reject" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Reject</MenuItem>
//                             <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
//                           </Select>
//                         </TableCell>
//                         <TableCell>
//                           <TextField
//                             size="small"
//                             value={item.remarks || ''}
//                             onChange={(e) => handleChecklistItemChange(index, 'remarks', e.target.value)}
//                             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//                             inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Typography sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#999' }}>
//                 No checklist items available
//               </Typography>
//             )}
//           </TabPanel>
//         </DialogContent>
//         <DialogActions>
//           <LightGrayOutlinedButton onClick={() => setEditDialogOpen(false)}>
//             Cancel
//           </LightGrayOutlinedButton>
//           <Button 
//             onClick={handleSaveEdit}
//             variant="contained"
//             disabled={saving}
//             startIcon={saving ? <CircularProgress size={20} /> : <Save />}
//             sx={{ 
//               fontFamily: '"Times New Roman", Times, serif',
//               backgroundColor: '#f0f0f0',
//               color: '#000000',
//               '&:hover': {
//                 backgroundColor: '#e0e0e0',
//               }
//             }}
//           >
//             {saving ? 'Saving...' : 'Save Changes'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteDialogOpen}
//         onClose={() => setDeleteDialogOpen(false)}
//       >
//         <DialogTitle sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>
//           Confirm Delete
//         </DialogTitle>
//         <DialogContent>
//           <TimesTypography sx={{ color: '#000000' }}>
//             Are you sure you want to delete handover record{' '}
//             {selectedHandover?.id}? This action cannot be undone.
//           </TimesTypography>
//         </DialogContent>
//         <DialogActions>
//           <LightGrayOutlinedButton onClick={() => setDeleteDialogOpen(false)}>
//             Cancel
//           </LightGrayOutlinedButton>
//           <Button 
//             onClick={handleDeleteConfirm}
//             color="error"
//             variant="contained"
//             sx={{ fontFamily: '"Times New Roman", Times, serif' }}
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }
//*********************************************************************************** */
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  TextField,
  InputAdornment,
  Chip,
  Grid,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Visibility,
  Edit,
  Delete,
  Search,
  Refresh,
  PictureAsPdf,
  Download,
  CalendarToday,
  Person,
  Business,
  Close,
  Print,
  Save,
  Assignment,
  VerifiedUser,
  Group,
  Home,
  LocationOn,
  ElectricalServices,
  Handshake
} from '@mui/icons-material';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { 
  GetDataFromApiWithParams, 
  DeleteAndGetResponse,
  ExecutePostWithParams, 
  UpdateAndGetResponse
} from "../../../../services/api/ExecuteApiRequests";

// Logo paths - using public folder with full URL
const IPDCLogo = `${window.location.origin}/IPDC_LOGO.jpg`;
const EthiopiaLogo = `${window.location.origin}/et logo.png`;

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#f5f5f5',
  fontFamily: '"Times New Roman", Times, serif',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafafa',
  },
  '&:hover': {
    backgroundColor: '#f0f0f0',
  },
}));

const TimesTypography = styled(Typography)(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif !important',
  color: '#000000',
}));

const ConsistentTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif',
  fontSize: '0.875rem',
  color: '#000000',
}));

const IconText = styled('span')(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif',
  fontSize: '0.875rem',
  color: '#000000',
}));

// Light Gray Button Styles
const LightGrayOutlinedButton = styled(Button)(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif',
  backgroundColor: '#f0f0f0',
  color: '#000000',
  borderColor: '#cccccc',
  '&:hover': {
    backgroundColor: '#e0e0e0',
    borderColor: '#999999',
  },
  '&:disabled': {
    backgroundColor: '#e0e0e0',
    color: '#999999',
  }
}));

const LightGrayContainedButton = styled(Button)(({ theme }) => ({
  fontFamily: '"Times New Roman", Times, serif',
  backgroundColor: '#f0f0f0',
  color: '#000000',
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
  '&:disabled': {
    backgroundColor: '#e0e0e0',
    color: '#999999',
  }
}));

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function HandoverListView() {
  const [handovers, setHandovers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedHandover, setSelectedHandover] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterStatus, setFilterStatus] = useState('all');
  const [refreshing, setRefreshing] = useState(false);
  const [editTabValue, setEditTabValue] = useState(0);
  const [landHandoverFormData, setLandHandoverFormData] = useState(null);
  const [editFormData, setEditFormData] = useState({
    id: '',
    agreement_id: '',
    date_of_handover: '',
    handed_over_by: '',
    handed_over_to: '',
    notes: '',
    description: '',
    park_id: '',
    signatures: [],
    checklist_items: []
  });
  const [saving, setSaving] = useState(false);
  
  // Fetch handovers on component mount and when page/filter changes
  useEffect(() => {
    fetchHandovers();
  }, [page, filterStatus]);

  const fetchHandovers = async () => {
    setLoading(true);
    try {
      const params = {
        page: page,
        status: filterStatus,
        search: searchTerm
      };
      
      const response = await GetDataFromApiWithParams(`parks/handover`, params);
      
      console.log("API Response:", response);
      
      if (Array.isArray(response)) {
        setHandovers(response);
        setTotalPages(Math.ceil(response.length / 10) || 1);
      } 
      else if (response && response.data && Array.isArray(response.data)) {
        setHandovers(response.data);
        setTotalPages(response.totalPages || 1);
      }
      else {
        console.warn("Unexpected response format:", response);
        setHandovers([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("Error fetching handovers:", error);
      toast.error("Failed to load handover records", { position: "top-right" });
      setHandovers([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Land Handover Form data
  const fetchLandHandoverForm = async (handoverId) => {
    try {
      const response = await GetDataFromApiWithParams(`parks/land-handover-form/${handoverId}`, {});
      if (response && response.data) {
        setLandHandoverFormData(response.data);
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching land handover form:", error);
      return null;
    }
  };

  const handleSearch = () => {
    setPage(1);
    fetchHandovers();
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    await fetchHandovers();
    setRefreshing(false);
    toast.success("Data refreshed successfully", { position: "top-right" });
  };

  const handleView = async (handover) => {
    setSelectedHandover(handover);
    await fetchLandHandoverForm(handover.id);
    setViewDialogOpen(true);
  };

  const handleEdit = (handover) => {
    console.log("Opening edit dialog for:", handover);
    setSelectedHandover(handover);
    setEditFormData({
      id: handover.id || '',
      agreement_id: handover.agreement_id || '',
      date_of_handover: handover.date_of_handover || '',
      handed_over_by: handover.handed_over_by || '',
      handed_over_to: handover.handed_over_to || '',
      notes: handover.notes || '',
      description: handover.description || '',
      park_id: handover.park_id || '',
      signatures: handover.signatures || [],
      checklist_items: handover.checklist_items || []
    });
    setEditTabValue(0);
    setEditDialogOpen(true);
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSignatureChange = (index, field, value) => {
    setEditFormData(prev => {
      const updatedSignatures = [...prev.signatures];
      updatedSignatures[index] = {
        ...updatedSignatures[index],
        [field]: value
      };
      return {
        ...prev,
        signatures: updatedSignatures
      };
    });
  };

  const handleChecklistItemChange = (index, field, value) => {
    setEditFormData(prev => {
      const updatedItems = [...prev.checklist_items];
      updatedItems[index] = {
        ...updatedItems[index],
        [field]: value
      };
      return {
        ...prev,
        checklist_items: updatedItems
      };
    });
  };

  const handleSaveEdit = async () => {
    setSaving(true);
    try {
      console.log("Saving edited data:", editFormData);
      await UpdateAndGetResponse(`parks/handover/${editFormData.id}`, editFormData);
      
      toast.success("Handover updated successfully", { position: "top-right" });
      setEditDialogOpen(false);
      fetchHandovers();
    } catch (error) {
      console.error("Error updating handover:", error);
      toast.error("Failed to update handover", { position: "top-right" });
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteClick = (handover) => {
    setSelectedHandover(handover);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedHandover) return;
    
    try {
      await DeleteAndGetResponse(`parks/handover/${selectedHandover.id}`);
      toast.success("Handover deleted successfully", { position: "top-right" });
      fetchHandovers();
    } catch (error) {
      console.error("Error deleting handover:", error);
      toast.error("Failed to delete handover", { position: "top-right" });
    } finally {
      setDeleteDialogOpen(false);
      setSelectedHandover(null);
    }
  };

  // Print Land Handover Form function
  const handlePrintLandHandoverForm = async () => {
    if (!selectedHandover) return;
    
    const formData = await fetchLandHandoverForm(selectedHandover.id);
    
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      const content = generateLandHandoverPrintContent(selectedHandover, formData);
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }
  };

// Generate print content for Land Handover Form with header on every page
const generateLandHandoverPrintContent = (handover, landFormData) => {
  const coordinates = landFormData?.coordinates || [
    { northing: '', easting: '' },
    { northing: '', easting: '' },
    { northing: '', easting: '' },
    { northing: '', easting: '' },
    { northing: '', easting: '' },
    { northing: '', easting: '' },
    { northing: '', easting: '' },
    { northing: '', easting: '' }
  ];

  const undergroundLines = landFormData?.undergroundLines || {
    stormDrainage: '',
    sewageDrainage: '',
    wasteDrainage: '',
    powerSupply: '',
    telecomLine: ''
  };

  const lessorRep = landFormData?.lessorRepresentative || { name: '', signature: '', date: '' };
  const lesseeRep = landFormData?.lesseeRepresentative || { name: '', signature: '', date: '' };
  const witnesses = landFormData?.witnesses || [
    { name: '', signature: '', date: '' },
    { name: '', signature: '', date: '' },
    { name: '', signature: '', date: '' }
  ];

  // Get the base URL from the current window location
  const baseUrl = window.location.origin;

  // SVG icons that match Material-UI style
  const HomeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2h-5v-7H9v7H5a2 2 0 0 1-2-2z"/></svg>`;
  const LocationIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>`;
  const ElectricalIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M18 2h-3v5h-2V2h-3v5h-2V2H5v8h2v10h10V10h2V2z"/></svg>`;
  const HandshakeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M17 11v2h-3v3h-2v-3H9v-3h3V8h2v3z"/><path d="M5 15l-3-7 4-2 2 4-3 5z"/><path d="M19 15l3-7-4-2-2 4 3 5z"/></svg>`;
  const PersonIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a237e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display: inline-block; vertical-align: middle; margin-right: 5px;"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`;

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Land Handover Form - ${handover.id}</title>
        <meta charset="UTF-8">
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Times New Roman', Times, serif;
            margin: 0;
            padding: 20px;
            color: #000000;
            background: white;
          }
          
          .print-container {
            max-width: 1100px;
            margin: 0 auto;
          }
          
          /* Header Styles - appears on every page */
          .header {
            text-align: center;
            margin-bottom: 30px;
            page-break-after: avoid;
          }
          
          .logo-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
          }
          
          .logo-left, .logo-right {
            width: 100px;
            min-height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          
          .logo-left img, .logo-right img {
            max-width: 100%;
            max-height: 80px;
            width: auto;
            height: auto;
          }
          
          .header-text {
            flex: 1;
            text-align: center;
            padding: 0 20px;
          }
          
          .header-text h1 {
            font-size: 16px;
            font-weight: bold;
            margin: 0;
          }
          
          .header-text h2 {
            font-size: 14px;
            font-weight: bold;
            margin: 5px 0;
          }
          
          .header-text h3 {
            font-size: 13px;
            font-weight: bold;
            text-decoration: underline;
            margin: 10px 0 0;
          }
          
          .header-line {
            border-top: 2px solid #1a237e;
            margin: 10px 0 20px;
          }
          
          /* Section Styles */
          .section {
            margin-bottom: 20px;
            page-break-inside: avoid;
          }
          
          .section-title {
            font-size: 14px;
            font-weight: bold;
            color: #1a237e;
            border-bottom: 2px solid #1a237e;
            padding-bottom: 5px;
            margin-bottom: 15px;
          }
          
          /* Grid Layouts */
          .grid-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 15px;
          }
          
          .grid-2 {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 15px;
          }
          
          .field {
            margin-bottom: 10px;
          }
          
          .field-label {
            font-weight: normal;
            margin-bottom: 3px;
          }
          
          .field-value {
            margin: 0;
            padding-bottom: 5px;
            border-bottom: 1px dotted #ccc;
          }
          
          /* Table Styles */
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          
          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }
          
          th {
            background-color: #e8eaf6;
            font-weight: bold;
          }
          
          /* Signature Box */
          .signature-box {
            border: 1px solid #ddd;
            padding: 15px;
            background-color: #fafafa;
          }
          
          .signature-box h4 {
            margin: 0 0 10px 0;
            font-size: 12px;
          }
          
          /* Empty signature line for users to sign on printed paper */
          .signature-line {
            border-bottom: 1px solid #000;
            margin-top: 5px;
            margin-bottom: 10px;
            width: 100%;
            height: 35px;
          }
          
          .signature-line-small {
            border-bottom: 1px solid #000;
            margin-top: 5px;
            margin-bottom: 5px;
            width: 100%;
            height: 25px;
          }
          
          /* Footer */
          .footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
            padding: 10px 0;
            background: white;
            border-top: 2px solid #1a237e;
            margin-top: 20px;
          }
          
          .footer-text {
            font-size: 9px;
            text-align: center;
            line-height: 1.4;
          }
          
          .footer-italic {
            font-style: italic;
            margin-top: 3px;
          }
          
          /* Page Break Control */
          .page-break-before {
            page-break-before: always;
          }
          
          .keep-together {
            page-break-inside: avoid;
          }
          
          /* Print-specific styles */
          @media print {
            body {
              margin: 0;
              padding: 0;
            }
            .footer {
              position: fixed;
              bottom: 0;
            }
            @page {
              size: A4;
              margin: 1.5cm;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <!-- Page 1 Header with Logos -->
          <div class="header">
            <div class="logo-container">
              <div class="logo-left">
                <img src="${baseUrl}/et%20logo.png" alt="Ethiopia Logo" />
              </div>
              <div class="header-text">
                <h1>THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA</h1>
                <h2>INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)</h2>
                <h3>HANDOVER FORM FOR ALLOCATED LAND (PLOT) TO TENANTS</h3>
              </div>
              <div class="logo-right">
                <img src="${baseUrl}/IPDC_LOGO.jpg" alt="IPDC Logo" />
              </div>
            </div>
            <div class="header-line"></div>
          </div>

          <!-- Basic Information Section -->
          <div class="section">
            <div class="section-title">${HomeIcon} Basic Information</div>
            <div class="grid-3">
              <div class="field">
                <div class="field-label">Date of Handover:</div>
                <div class="field-value">${landFormData?.date || handover.date_of_handover || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Industrial Park:</div>
                <div class="field-value">${landFormData?.industrialPark || handover.park_id || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Lessee (Tenant) Name:</div>
                <div class="field-value">${landFormData?.lesseeName || handover.handed_over_to || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Title Deed Number:</div>
                <div class="field-value">${landFormData?.titleDeedNumber || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Location of Plot (Block):</div>
                <div class="field-value">${landFormData?.plotLocation || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Area of Plot (sq. meters):</div>
                <div class="field-value">${landFormData?.area || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Zoning:</div>
                <div class="field-value">${landFormData?.zoning || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">For Manufacturing of:</div>
                <div class="field-value">${landFormData?.manufacturingFor || ''}</div>
              </div>
            </div>
          </div>

          <!-- Coordinates of Plot -->
          <div class="section">
            <div class="section-title">${LocationIcon} Coordinates of Plot</div>
            <table>
              <thead>
                <tr>
                  <th>Point</th>
                  <th>Northing</th>
                  <th>Easting</th>
                </tr>
              </thead>
              <tbody>
                ${coordinates.map((coord, idx) => `
                  <tr>
                    <td style="font-weight: bold;">${idx + 1}</td>
                    <td>${coord.northing || ''}</td>
                    <td>${coord.easting || ''}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>

          <!-- Underground Utility Lines - First 4 items -->
          <div class="section">
            <div class="section-title">${ElectricalIcon} Underground Utility Lines and Manholes</div>
            <div class="grid-2">
              <div class="field">
                <div class="field-label">Branch Storm Drainage Line with Rectangular Concrete Cover Manhole:</div>
                <div class="field-value">${undergroundLines.stormDrainage || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Branch Sewage Drainage Line with Circular Concrete Cover Manhole:</div>
                <div class="field-value">${undergroundLines.sewageDrainage || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Branch Waste Drainage with Circular Concrete Cover Manhole:</div>
                <div class="field-value">${undergroundLines.wasteDrainage || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Power Supply Lines with Circular Steel Cover Manhole:</div>
                <div class="field-value">${undergroundLines.powerSupply || ''}</div>
              </div>
            </div>
          </div>

          <!-- Page Break - Remaining items on Page 2 -->
          <div class="page-break-before"></div>

          <!-- Page 2 Header with Logos (repeats) -->
          <div class="header">
            <div class="logo-container">
              <div class="logo-left">
                <img src="${baseUrl}/et%20logo.png" alt="Ethiopia Logo" />
              </div>
              <div class="header-text">
                <h1>THE FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA</h1>
                <h2>INDUSTRIAL PARKS DEVELOPMENT CORPORATION (IPDC)</h2>
                <h3>HANDOVER FORM FOR ALLOCATED LAND (PLOT) TO TENANTS</h3>
              </div>
              <div class="logo-right">
                <img src="${baseUrl}/IPDC_LOGO.jpg" alt="IPDC Logo" />
              </div>
            </div>
            <div class="header-line"></div>
          </div>

          <!-- Telecom Line (Page 2) -->
          <div class="section">
            <div class="section-title">${ElectricalIcon} Underground Utility Lines and Manholes (Continued)</div>
            <div class="field">
              <div class="field-label">Telecom Line with Circular Steel Cover Manhole:</div>
              <div class="field-value">${undergroundLines.telecomLine || ''}</div>
            </div>
          </div>

          <!-- Additional Infrastructure -->
          <div class="section">
            <div class="section-title">Additional Infrastructure</div>
            <div class="grid-3">
              <div class="field">
                <div class="field-label">Water Supply Line:</div>
                <div class="field-value">${landFormData?.waterSupplyLine || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Location of Entrance Gate:</div>
                <div class="field-value">${landFormData?.entranceGate || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Bench Mark:</div>
                <div class="field-value">${landFormData?.benchMark || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">RMU:</div>
                <div class="field-value">${landFormData?.rmu || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Walkway:</div>
                <div class="field-value">${landFormData?.walkway || ''}</div>
              </div>
              <div class="field">
                <div class="field-label">Landscape of the Plot:</div>
                <div class="field-value">${landFormData?.landscape || ''}</div>
              </div>
            </div>
          </div>

          <!-- Representatives Signatures -->
          <div class="section">
            <div class="section-title">${HandshakeIcon} Representatives Signatures</div>
            <div class="grid-2">
              <div class="signature-box">
                <h4>Representative of Lessor (IPDC)</h4>
                <div class="field">
                  <div class="field-label">Name:</div>
                  <div class="field-value">${lessorRep.name || '_________________________'}</div>
                </div>
                <div class="field">
                  <div class="field-label">Signature:</div>
                  <div class="signature-line"></div>
                </div>
                <div class="field">
                  <div class="field-label">Date:</div>
                  <div class="field-value">${lessorRep.date || '___________'}</div>
                </div>
              </div>
              <div class="signature-box">
                <h4>Representative of Lessee (Investor)</h4>
                <div class="field">
                  <div class="field-label">Name:</div>
                  <div class="field-value">${lesseeRep.name || '_________________________'}</div>
                </div>
                <div class="field">
                  <div class="field-label">Signature:</div>
                  <div class="signature-line"></div>
                </div>
                <div class="field">
                  <div class="field-label">Date:</div>
                  <div class="field-value">${lesseeRep.date || '___________'}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Witnesses -->
          <div class="section">
            <div class="section-title">${PersonIcon} Witnesses</div>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Signature</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                ${witnesses.map((witness, idx) => `
                  <tr>
                    <td style="font-weight: bold;">${idx + 1}</td>
                    <td>${witness.name || '_________________'}</td>
                    <td><div class="signature-line-small"></div></td>
                    <td>${witness.date || '___________'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>

          <!-- Footer -->
          <div class="footer">
            <div class="footer-text">
              ➢ This Handover form is prepared in four copies, one for the company, one for IPDC file, one for the Operation and Industrial Park Management and one for IP branch Office.
            </div>
            <div class="footer-text footer-italic">
              ➢ This certificate is certified having of authorized Lessee and IPDC Stamp is provided.
            </div>
          </div>
        </div>
      </body>
    </html>
  `;
};

  const getStatusChip = (status) => {
    const bgColorMap = {
      'Completed': '#e0e0e0',
      'Pending': '#f5f5f5',
      'In Progress': '#d3d3d3',
      'default': '#f0f0f0'
    };
    
    return (
      <Chip 
        label={status || 'Unknown'} 
        size="small"
        sx={{ 
          fontFamily: '"Times New Roman", Times, serif',
          backgroundColor: bgColorMap[status] || bgColorMap.default,
          color: '#000000',
          fontWeight: 400,
          fontSize: '0.75rem',
        }}
      />
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <Box sx={{ p: 3, fontFamily: '"Times New Roman", Times, serif' }}>
      <ToastContainer 
        toastStyle={{ fontFamily: '"Times New Roman", Times, serif' }}
      />
      
      {/* Header */}
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <TimesTypography variant="h5" sx={{ fontWeight: 'bold' }}>
            Handover Records
          </TimesTypography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <LightGrayOutlinedButton
              variant="outlined"
              startIcon={<Refresh />}
              onClick={handleRefresh}
              disabled={refreshing}
            >
              {refreshing ? 'Refreshing...' : 'Refresh'}
            </LightGrayOutlinedButton>
            
            <LightGrayContainedButton
              variant="contained"
              startIcon={<PictureAsPdf />}
            >
              Export Report
            </LightGrayContainedButton>
          </Box>
        </Box>
      </Paper>

      {/* Filters and Search */}
      <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by ID, Investor, or Description..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: searchTerm && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchTerm('')}>
                      <Close fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
                style: { fontFamily: '"Times New Roman", Times, serif' }
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Status Filter</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="Status Filter"
                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
              >
                <MenuItem value="all" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>All Status</MenuItem>
                <MenuItem value="Completed" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Completed</MenuItem>
                <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
                <MenuItem value="In Progress" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>In Progress</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <LightGrayContainedButton
              variant="contained"
              onClick={handleSearch}
              fullWidth
            >
              Search
            </LightGrayContainedButton>
          </Grid>
          <Grid item xs={12} md={3}>
            <TimesTypography variant="body2" color="textSecondary">
              Total Records: {handovers.length}
            </TimesTypography>
          </Grid>
        </Grid>
      </Paper>

      {/* Table */}
      <Paper elevation={2} sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 500 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell>ID</StyledTableCell>
                <StyledTableCell>Handover Date</StyledTableCell>
                <StyledTableCell>Handed Over By</StyledTableCell>
                <StyledTableCell>Handed Over To</StyledTableCell>
                <StyledTableCell>Agreement ID</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                    <TimesTypography sx={{ mt: 2 }}>Loading handover records...</TimesTypography>
                  </TableCell>
                </TableRow>
              ) : handovers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                    <TimesTypography variant="h6" color="textSecondary">
                      No handover records found
                    </TimesTypography>
                  </TableCell>
                </TableRow>
              ) : (
                handovers.map((handover) => (
                  <StyledTableRow key={handover.id}>
                    <ConsistentTableCell>{handover.id}</ConsistentTableCell>
                    <ConsistentTableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <CalendarToday fontSize="small" sx={{ color: '#000000' }} />
                        <IconText>{formatDate(handover.date_of_handover)}</IconText>
                      </Box>
                    </ConsistentTableCell>
                    <ConsistentTableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Person fontSize="small" sx={{ color: '#000000' }} />
                        <IconText>{handover.handed_over_by}</IconText>
                      </Box>
                    </ConsistentTableCell>
                    <ConsistentTableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Person fontSize="small" sx={{ color: '#000000' }} /> 
                        <IconText>{handover.handed_over_to}</IconText>
                      </Box>
                    </ConsistentTableCell>
                    <ConsistentTableCell>{handover.agreement_id}</ConsistentTableCell>
                    <ConsistentTableCell>{handover.description || "No"}</ConsistentTableCell>
                    <ConsistentTableCell align="center">
                      <Tooltip title="View Details">
                        <IconButton 
                          size="small" 
                          sx={{ color: '#000000' }}
                          onClick={() => handleView(handover)}
                        >
                          <Visibility fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit">
                        <IconButton 
                          size="small" 
                          sx={{ color: '#000000' }}
                          onClick={() => handleEdit(handover)}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Print Land Handover Form">
                        <IconButton 
                          size="small" 
                          sx={{ color: '#000000' }}
                          onClick={() => {
                            setSelectedHandover(handover);
                            handlePrintLandHandoverForm();
                          }}
                        >
                          <Print fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      {handover.signed_document_url && (
                        <Tooltip title="Download Document">
                          <IconButton 
                            size="small" 
                            sx={{ color: '#000000' }}
                            href={handover.signed_document_url}
                            download
                          >
                            <Download fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="Delete">
                        <IconButton 
                          size="small" 
                          color="error"
                          onClick={() => handleDeleteClick(handover)}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </ConsistentTableCell>
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Pagination */}
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <Pagination 
            count={totalPages} 
            page={page} 
            onChange={(e, value) => setPage(value)}
            color="primary"
            sx={{
              '& .MuiPaginationItem-root': {
                fontFamily: '"Times New Roman", Times, serif'
              }
            }}
          />
        </Box>
      </Paper>

      {/* View Details Dialog */}
      <Dialog 
        open={viewDialogOpen} 
        onClose={() => setViewDialogOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontFamily: '"Times New Roman", Times, serif',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          Handover Details - {selectedHandover?.id}
          <Box>
            <Tooltip title="Print Land Handover Form">
              <IconButton onClick={handlePrintLandHandoverForm} sx={{ mr: 1 }}>
                <Print />
              </IconButton>
            </Tooltip>
            <IconButton onClick={() => setViewDialogOpen(false)}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedHandover && (
            <Grid container spacing={3}>
              {/* Basic Information */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                      <Home sx={{ mr: 1, fontSize: '1.2rem' }} /> Basic Information
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={4}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Handover ID: {selectedHandover.id}
                        </TimesTypography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Handover Date: {formatDate(selectedHandover.date_of_handover)}
                        </TimesTypography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Park ID: {selectedHandover.park_id || 'N/A'}
                        </TimesTypography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Agreement ID: {selectedHandover.agreement_id || 'N/A'}
                        </TimesTypography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Handed Over By: {selectedHandover.handed_over_by || 'N/A'}
                        </TimesTypography>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Handed Over To: {selectedHandover.handed_over_to || 'N/A'}
                        </TimesTypography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Description and Notes */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ mb: 2 }}>
                  <CardContent>
                    <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
                      Description & Notes
                    </TimesTypography>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Description: {selectedHandover.description || 'No description provided'}
                        </TimesTypography>
                      </Grid>
                      <Grid item xs={12}>
                        <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                          Notes: {selectedHandover.notes || 'No notes provided'}
                        </TimesTypography>
                      </Grid>
                      {selectedHandover.attachment_paths && (
                        <Grid item xs={12}>
                          <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                            Attachment: {selectedHandover.attachment_paths}
                          </TimesTypography>
                          <Button
                            variant="outlined"
                            startIcon={<Download />}
                            href={selectedHandover.attachment_paths}
                            target="_blank"
                            size="small"
                            sx={{ 
                              mt: 1, 
                              fontFamily: '"Times New Roman", Times, serif',
                              color: '#000000',
                              borderColor: '#cccccc'
                            }}
                          >
                            Download Attachment
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Land Handover Form Data Section */}
              {landHandoverFormData && (
                <>
                  {/* Plot Information */}
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ mb: 2 }}>
                      <CardContent>
                        <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                          <LocationOn sx={{ mr: 1, fontSize: '1.2rem' }} /> Plot Information
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6} md={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Lessee Name: {landHandoverFormData.lesseeName || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Title Deed Number: {landHandoverFormData.titleDeedNumber || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Plot Location: {landHandoverFormData.plotLocation || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Area: {landHandoverFormData.area || 'N/A'} sq. meters
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Zoning: {landHandoverFormData.zoning || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Manufacturing For: {landHandoverFormData.manufacturingFor || 'N/A'}
                            </TimesTypography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Coordinates */}
                  {landHandoverFormData.coordinates && (
                    <Grid item xs={12}>
                      <Card variant="outlined" sx={{ mb: 2 }}>
                        <CardContent>
                          <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                            <LocationOn sx={{ mr: 1, fontSize: '1.2rem' }} /> Coordinates of Plot (8 Points)
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
                            <Table size="small" stickyHeader>
                              <TableHead>
                                <TableRow sx={{ backgroundColor: '#e8eaf6' }}>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Point</TableCell>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Northing (X)</TableCell>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Easting (Y)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {landHandoverFormData.coordinates.map((coord, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{idx + 1}</TableCell>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{coord.northing || ''}</TableCell>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{coord.easting || ''}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                  {/* Utility Lines */}
                  {landHandoverFormData.undergroundLines && (
                    <Grid item xs={12}>
                      <Card variant="outlined" sx={{ mb: 2 }}>
                        <CardContent>
                          <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                            <ElectricalServices sx={{ mr: 1, fontSize: '1.2rem' }} /> Underground Utility Lines and Manholes
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                Storm Drainage: {landHandoverFormData.undergroundLines.stormDrainage || 'N/A'}
                              </TimesTypography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                Sewage Drainage: {landHandoverFormData.undergroundLines.sewageDrainage || 'N/A'}
                              </TimesTypography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                Waste Drainage: {landHandoverFormData.undergroundLines.wasteDrainage || 'N/A'}
                              </TimesTypography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                Power Supply: {landHandoverFormData.undergroundLines.powerSupply || 'N/A'}
                              </TimesTypography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                Telecom Line: {landHandoverFormData.undergroundLines.telecomLine || 'N/A'}
                              </TimesTypography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                  {/* Additional Infrastructure */}
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ mb: 2 }}>
                      <CardContent>
                        <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
                          Additional Infrastructure
                        </TimesTypography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Water Supply Line: {landHandoverFormData.waterSupplyLine || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Entrance Gate: {landHandoverFormData.entranceGate || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Bench Mark: {landHandoverFormData.benchMark || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              RMU: {landHandoverFormData.rmu || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Walkway: {landHandoverFormData.walkway || 'N/A'}
                            </TimesTypography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                              Landscape: {landHandoverFormData.landscape || 'N/A'}
                            </TimesTypography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Signatures */}
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ mb: 2 }}>
                      <CardContent>
                        <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                          <Handshake sx={{ mr: 1, fontSize: '1.2rem' }} /> Representatives Signatures
                        </Typography>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={6}>
                            <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                              <TimesTypography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Representative of Lessor (IPDC)
                              </TimesTypography>
                              <TimesTypography variant="body2">Name: {landHandoverFormData.lessorRepresentative?.name || 'N/A'}</TimesTypography>
                              <TimesTypography variant="body2">Signature: {landHandoverFormData.lessorRepresentative?.signature ? '(Signature on file)' : 'N/A'}</TimesTypography>
                              <TimesTypography variant="body2">Date: {landHandoverFormData.lessorRepresentative?.date || 'N/A'}</TimesTypography>
                            </Paper>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                              <TimesTypography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Representative of Lessee (Investor)
                              </TimesTypography>
                              <TimesTypography variant="body2">Name: {landHandoverFormData.lesseeRepresentative?.name || 'N/A'}</TimesTypography>
                              <TimesTypography variant="body2">Signature: {landHandoverFormData.lesseeRepresentative?.signature ? '(Signature on file)' : 'N/A'}</TimesTypography>
                              <TimesTypography variant="body2">Date: {landHandoverFormData.lesseeRepresentative?.date || 'N/A'}</TimesTypography>
                            </Paper>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Witnesses */}
                  {landHandoverFormData.witnesses && (
                    <Grid item xs={12}>
                      <Card variant="outlined" sx={{ mb: 2 }}>
                        <CardContent>
                          <Typography variant="h6" sx={{ mb: 1.5, color: '#1a237e', borderBottom: '2px solid #1a237e', fontSize: '1rem' }}>
                            <Person sx={{ mr: 1, fontSize: '1.2rem' }} /> Witnesses
                          </Typography>
                          <Divider sx={{ mb: 2 }} />
                          <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: '#e8eaf6' }}>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>#</TableCell>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Name</TableCell>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Signature</TableCell>
                                  <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Date</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {landHandoverFormData.witnesses.map((witness, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{idx + 1}</TableCell>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{witness.name || 'N/A'}</TableCell>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{witness.signature ? '(Signature on file)' : 'N/A'}</TableCell>
                                    <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{witness.date || 'N/A'}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}
                </>
              )}

              {/* Signatures Section from handover */}
              {selectedHandover.signatures && selectedHandover.signatures.length > 0 && !landHandoverFormData && (
                <Grid item xs={12}>
                  <Card variant="outlined" sx={{ mb: 2 }}>
                    <CardContent>
                      <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
                        Signatures & Witnesses
                      </TimesTypography>
                      <Divider sx={{ mb: 2 }} />
                      {selectedHandover.signatures.map((sig, index) => (
                        <Box key={index} sx={{ mt: 2 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                              <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                                <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
                                  IPDC Vice E & Technic Manager
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Name: {sig.ipdc_vice_name || 'N/A'}
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Position: {sig.ipdc_vice_position || 'N/A'}
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Date: {formatDate(sig.ipdc_vice_date)}
                                </TimesTypography>
                              </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                                <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
                                  Investor Company
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Name: {sig.investor_name || 'N/A'}
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Position: {sig.investor_position || 'N/A'}
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Date: {formatDate(sig.investor_date)}
                                </TimesTypography>
                              </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                                <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
                                  IPDC KISEZ Manager
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Name: {sig.ipdc_kisez_name || 'N/A'}
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Position: {sig.ipdc_kisez_position || 'N/A'}
                                </TimesTypography>
                                <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                  Date: {formatDate(sig.ipdc_kisez_date)}
                                </TimesTypography>
                              </Paper>
                            </Grid>
                            <Grid item xs={12}>
                              <Paper variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9', mt: 1 }}>
                                <TimesTypography variant="subtitle2" gutterBottom sx={{ color: '#000000' }}>
                                  Witnesses
                                </TimesTypography>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={4}>
                                    <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                      Witness 1: {sig.witness1_name || 'N/A'}
                                    </TimesTypography>
                                  </Grid>
                                  <Grid item xs={12} sm={4}>
                                    <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                      Witness 2: {sig.witness2_name || 'N/A'}
                                    </TimesTypography>
                                  </Grid>
                                  <Grid item xs={12} sm={4}>
                                    <TimesTypography variant="body2" sx={{ color: '#000000' }}>
                                      Witness 3: {sig.witness3_name || 'N/A'}
                                    </TimesTypography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            </Grid>
                          </Grid>
                        </Box>
                      ))}
                    </CardContent>
                  </Card>
                </Grid>
              )}

              {/* Checklist Items Section */}
              {selectedHandover.checklist_items && selectedHandover.checklist_items.length > 0 && (
                <Grid item xs={12}>
                  <Card variant="outlined">
                    <CardContent>
                      <TimesTypography variant="h6" gutterBottom sx={{ color: '#000000', fontWeight: 'normal' }}>
                        Checklist Items ({selectedHandover.checklist_items.length})
                      </TimesTypography>
                      <Divider sx={{ mb: 2 }} />
                      <TableContainer component={Paper} variant="outlined" sx={{ mt: 2, maxHeight: 300 }}>
                        <Table size="small" stickyHeader>
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                              <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>No.</TableCell>
                              <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Item Name</TableCell>
                              <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Status</TableCell>
                              <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Accept/Reject</TableCell>
                              <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000', fontWeight: 'bold' }}>Remarks</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedHandover.checklist_items.map((item) => (
                              <TableRow key={item.id}>
                                <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.inspection_no}</TableCell>
                                <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.item_name}</TableCell>
                                <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.status || 'N/A'}</TableCell>
                                <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>
                                  <Chip 
                                    label={item.accept_reject || 'Pending'} 
                                    size="small"
                                    sx={{
                                      fontFamily: '"Times New Roman", Times, serif',
                                      backgroundColor: 
                                        item.accept_reject === 'Accept' ? '#e0e0e0' : 
                                        item.accept_reject === 'Reject' ? '#e0e0e0' : 
                                        '#f5f5f5',
                                      color: '#000000'
                                    }}
                                  />
                                </TableCell>
                                <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>{item.remarks || 'N/A'}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <LightGrayOutlinedButton onClick={() => setViewDialogOpen(false)}>
            Close
          </LightGrayOutlinedButton>
        </DialogActions>
      </Dialog>

      {/* Edit Handover Dialog - Keep existing code */}
      <Dialog 
        open={editDialogOpen} 
        onClose={() => setEditDialogOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ 
          fontFamily: '"Times New Roman", Times, serif',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          Edit Handover - {editFormData.id}
          <IconButton onClick={() => setEditDialogOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs 
              value={editTabValue} 
              onChange={(e, newValue) => setEditTabValue(newValue)}
              aria-label="edit handover tabs"
            >
              <Tab 
                icon={<Business />} 
                label="Basic Info" 
                iconPosition="start"
                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
              />
              <Tab 
                icon={<VerifiedUser />} 
                label="Signatures" 
                iconPosition="start"
                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
              />
              <Tab 
                icon={<Assignment />} 
                label="Checklist Items" 
                iconPosition="start"
                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
              />
            </Tabs>
          </Box>

          {/* Basic Information Tab */}
          <TabPanel value={editTabValue} index={0}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Agreement ID"
                  name="agreement_id"
                  value={editFormData.agreement_id}
                  onChange={handleEditFormChange}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Handover Date"
                  name="date_of_handover"
                  type="date"
                  value={editFormData.date_of_handover}
                  onChange={handleEditFormChange}
                  InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Handed Over By"
                  name="handed_over_by"
                  value={editFormData.handed_over_by}
                  onChange={handleEditFormChange}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Handed Over To"
                  name="handed_over_to"
                  value={editFormData.handed_over_to}
                  onChange={handleEditFormChange}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Park ID"
                  name="park_id"
                  value={editFormData.park_id}
                  onChange={handleEditFormChange}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Description"
                  name="description"
                  multiline
                  rows={2}
                  value={editFormData.description}
                  onChange={handleEditFormChange}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Notes"
                  name="notes"
                  multiline
                  rows={2}
                  value={editFormData.notes}
                  onChange={handleEditFormChange}
                  sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                  InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                  inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                />
              </Grid>
            </Grid>
          </TabPanel>

          {/* Signatures Tab */}
          <TabPanel value={editTabValue} index={1}>
            {editFormData.signatures && editFormData.signatures.length > 0 ? (
              editFormData.signatures.map((sig, index) => (
                <Accordion key={index} defaultExpanded={index === 0}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontFamily: '"Times New Roman", Times, serif' }}>
                      Signature Set {index + 1}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
                            IPDC Vice E & Technic Manager
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            label="Name"
                            value={sig.ipdc_vice_name || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_vice_name', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Position"
                            value={sig.ipdc_vice_position || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_vice_position', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Signature"
                            value={sig.ipdc_vice_signature || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_vice_signature', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Date"
                            type="date"
                            value={sig.ipdc_vice_date || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_vice_date', e.target.value)}
                            InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                        </Card>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
                            Investor Company
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            label="Name"
                            value={sig.investor_name || ''}
                            onChange={(e) => handleSignatureChange(index, 'investor_name', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Position"
                            value={sig.investor_position || ''}
                            onChange={(e) => handleSignatureChange(index, 'investor_position', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Signature"
                            value={sig.investor_signature || ''}
                            onChange={(e) => handleSignatureChange(index, 'investor_signature', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Date"
                            type="date"
                            value={sig.investor_date || ''}
                            onChange={(e) => handleSignatureChange(index, 'investor_date', e.target.value)}
                            InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                        </Card>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
                            IPDC KISEZ Manager
                          </Typography>
                          <TextField
                            fullWidth
                            size="small"
                            label="Name"
                            value={sig.ipdc_kisez_name || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_name', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Position"
                            value={sig.ipdc_kisez_position || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_position', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Signature"
                            value={sig.ipdc_kisez_signature || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_signature', e.target.value)}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                          <TextField
                            fullWidth
                            size="small"
                            label="Date"
                            type="date"
                            value={sig.ipdc_kisez_date || ''}
                            onChange={(e) => handleSignatureChange(index, 'ipdc_kisez_date', e.target.value)}
                            InputLabelProps={{ shrink: true, sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                            sx={{ mt: 1, fontFamily: '"Times New Roman", Times, serif' }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                        </Card>
                      </Grid>

                      <Grid item xs={12}>
                        <Card variant="outlined" sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>
                            Witnesses
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Witness 1"
                                value={sig.witness1_name || ''}
                                onChange={(e) => handleSignatureChange(index, 'witness1_name', e.target.value)}
                                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                                InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                                inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Witness 2"
                                value={sig.witness2_name || ''}
                                onChange={(e) => handleSignatureChange(index, 'witness2_name', e.target.value)}
                                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                                InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                                inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Witness 3"
                                value={sig.witness3_name || ''}
                                onChange={(e) => handleSignatureChange(index, 'witness3_name', e.target.value)}
                                sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                                InputLabelProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                                inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                              />
                            </Grid>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <Typography sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#999' }}>
                No signature data available
              </Typography>
            )}
          </TabPanel>

          {/* Checklist Items Tab */}
          <TabPanel value={editTabValue} index={2}>
            {editFormData.checklist_items && editFormData.checklist_items.length > 0 ? (
              <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>No.</TableCell>
                      <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Item Name</TableCell>
                      <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Status</TableCell>
                      <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Accept/Reject</TableCell>
                      <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif', fontWeight: 'bold' }}>Remarks</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {editFormData.checklist_items.map((item, index) => (
                      <TableRow key={item.id || index}>
                        <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{item.inspection_no}</TableCell>
                        <TableCell sx={{ fontFamily: '"Times New Roman", Times, serif' }}>{item.item_name}</TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={item.status || ''}
                            onChange={(e) => handleChecklistItemChange(index, 'status', e.target.value)}
                            sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                        </TableCell>
                        <TableCell>
                          <Select
                            size="small"
                            value={item.accept_reject || 'Pending'}
                            onChange={(e) => handleChecklistItemChange(index, 'accept_reject', e.target.value)}
                            sx={{ fontFamily: '"Times New Roman", Times, serif', minWidth: 100 }}
                          >
                            <MenuItem value="Accept" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Accept</MenuItem>
                            <MenuItem value="Reject" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Reject</MenuItem>
                            <MenuItem value="Pending" sx={{ fontFamily: '"Times New Roman", Times, serif' }}>Pending</MenuItem>
                          </Select>
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            value={item.remarks || ''}
                            onChange={(e) => handleChecklistItemChange(index, 'remarks', e.target.value)}
                            sx={{ fontFamily: '"Times New Roman", Times, serif' }}
                            inputProps={{ sx: { fontFamily: '"Times New Roman", Times, serif' } }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#999' }}>
                No checklist items available
              </Typography>
            )}
          </TabPanel>
        </DialogContent>
        <DialogActions>
          <LightGrayOutlinedButton onClick={() => setEditDialogOpen(false)}>
            Cancel
          </LightGrayOutlinedButton>
          <Button 
            onClick={handleSaveEdit}
            variant="contained"
            disabled={saving}
            startIcon={saving ? <CircularProgress size={20} /> : <Save />}
            sx={{ 
              fontFamily: '"Times New Roman", Times, serif',
              backgroundColor: '#f0f0f0',
              color: '#000000',
              '&:hover': {
                backgroundColor: '#e0e0e0',
              }
            }}
          >
            {saving ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle sx={{ fontFamily: '"Times New Roman", Times, serif', color: '#000000' }}>
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <TimesTypography sx={{ color: '#000000' }}>
            Are you sure you want to delete handover record{' '}
            {selectedHandover?.id}? This action cannot be undone.
          </TimesTypography>
        </DialogContent>
        <DialogActions>
          <LightGrayOutlinedButton onClick={() => setDeleteDialogOpen(false)}>
            Cancel
          </LightGrayOutlinedButton>
          <Button 
            onClick={handleDeleteConfirm}
            color="error"
            variant="contained"
            sx={{ fontFamily: '"Times New Roman", Times, serif' }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}